<div class="skills-dialog">
  <div class="skills-dialog__head">
    <div class="skills-dialog__title">{{ data.title | translate }}</div>
    <svg-icon
      class="skills-dialog__close"
      src="/assets/icons/close-modal.svg"
      (click)="dialogRef.close()"
    ></svg-icon>
  </div>

  <mat-dialog-content>
    <hrra-skills
      [skills]="draftSkills"
      [userType]="userType.Anonymous"
      [editable]="false"
      [removable]="true"
      [compact]="true"
      (onRemoveSkill)="removeSkill($event)"
    ></hrra-skills>

    @if (draftSkills.length > 0) {
      <span class="skills-dialog__clear" (click)="clearAll()">
        {{ 'label.ClearFilter' | translate }}
      </span>
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="skills-dialog__buttons">
      <app-button
        (click)="save()"
        [text]="'label.Save' | translate"
        [type]="buttonType.coloured"
        [typeAttribute]="buttonAttributeType.submit"
        class="skills-dialog__save"
      ></app-button>
      <app-button
        [mat-dialog-close]="undefined"
        [text]="'label.Cancel' | translate"
        [type]="buttonType.uncoloured"
        [typeAttribute]="buttonAttributeType.button"
      ></app-button>
    </div>
  </mat-dialog-actions>
</div>
